import React from "react";
// APIモジュール
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  Link,
  Typography,
} from "@material-ui/core";
import { StyledTableCell, StyledTableRow } from "../modules/modules";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
  table: {
    width: "100%",
    maxHeight: 300,
  },
}));

export default function ShopLicense(props) {
  const classes = useStyles();
  const profile = props.profile;
  const userShop = props.userShop;

  return (
    <React.Fragment>
      <Typography variant="h4" align="center" gutterBottom>
        {profile.name ? profile.name : "(名前未登録)"}
        さんが取得しているショップリスト
      </Typography>
      <TableContainer className={classes.table}>
        <Table stickyHeader>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell align="left">ショップ名</StyledTableCell>
              <StyledTableCell align="left">ショップのリンク</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {userShop.map((row) => {
              return (
                <StyledTableRow key={row.id}>
                  <StyledTableCell>{row.name}</StyledTableCell>
                  <StyledTableCell>
                    <Link color="textSecondary" href={row.link}>
                      {row.link}
                    </Link>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </React.Fragment>
  );
}
